window.addEventListener("load", function (event) {
    window.setTimeout(function () {
      // electricity
      $("#png1").click(function () {
        getElectricData().then((reads) => renderElectricChart(reads));
        $("#png1").css("opacity", "1");
        $("#png2").css("opacity", "0.5");
        $("#png3").css("opacity", "0.5");
        $(".chart-widget-section-indicator").css({
          "background-color": "#e0a234",
          transform: "translateX(-42px)",
        });
      });
  
      // water
      $("#png2").click(function () {
        getWaterData().then((reads) => renderWaterChart(reads));
        $("#png1").css("opacity", "0.5");
        $("#png2").css("opacity", "1");
        $("#png3").css("opacity", "0.5");
        $(".chart-widget-section-indicator").css({
          "background-color": "#649bc4",
          transform: "translateX(0px)",
        });
      });
  
      // gas
      $("#png3").click(function () {
        getGasData().then((reads) => renderGasChart(reads));
        $("#png1").css("opacity", "0.5");
        $("#png2").css("opacity", "0.5");
        $("#png3").css("opacity", "1");
        $(".chart-widget-section-indicator").css({
          "background-color": "#e26826",
          transform: "translateX(44px)",
        });
      });
  
      $("#png1-2").click(function () {
        getElectricData().then((reads) => renderElectricChartMobile(reads));
        $("#png1-2").css("opacity", "1");
        $("#png2-2").css("opacity", "0.5");
        $("#png3-2").css("opacity", "0.5");
        $("#chart-widget-section-indicator").css({
          "background-color": "#e0a234",
          transform: "translateX(-42px)",
        });
      });
  
      // water
      $("#png2-2").click(function () {
        getWaterData().then((reads) => renderWaterChartMobile(reads));
        $("#png1-2").css("opacity", "0.5");
        $("#png2-2").css("opacity", "1");
        $("#png3-2").css("opacity", "0.5");
        $("#chart-widget-section-indicator").css({
          "background-color": "#649bc4",
          transform: "translateX(0px)",
        });
      });
  
      // gas
      $("#png3-2").click(function () {
        getGasData().then((reads) => renderGasChartMobile(reads));
        $("#png1-2").css("opacity", "0.5");
        $("#png2-2").css("opacity", "0.5");
        $("#png3-2").css("opacity", "1");
        $("#chart-widget-section-indicator").css({
          "background-color": "#e26826",
          transform: "translateX(44px)",
        });
      });
  
      Highcharts.setOptions({
        global: {
          useUTC: false,
        },
      });
  
      function getData(numberOfReads = 1) {
        const url = `https://api.ekmpush.com/readMeter?key=MTAxMDoyMDIw&cnt=${numberOfReads}&format=json&fields=kWh_Tot~RMS_Watts_Tot&timezone=US~Pacific&meters=000350000900`;
        return fetch(url, {
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
          .then((response) => {
            const readData = response.readMeter.ReadSet[0].ReadData;
            const finalReads = [];
            let i = 1;
            readData.reverse().forEach((read) => {
              let time = new Date().getTime();
              if (read.Good) {
                finalReads.push([
                  read.Time_Stamp_UTC_ms,
                  Number(read.RMS_Watts_Tot),
                  read.kWh_Tot,
                ]);
                i++;
              }
            });

            return finalReads;
          });
      }
  
      function getElectricData() {
        const url = `https://summary.ekmmetering.com/summary?client=Widget&meters=300001290&key=MTAxMDoyMDIw&fields=kWh_Tot_Diff&report=dy&format=json&normalize=1&limit=30&timelimit=720&timezone=America~Los_Angeles`;
        return fetch(url, {
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
          .then((response) => {
            const readData = response;
            const finalReads = {};
            finalReads.data = [];
            finalReads.dates = [];
            readData.forEach((read) => {
              const date = Highcharts.dateFormat(
                "%e %b",
                read.Start_Time_Stamp_UTC_ms
              );
              finalReads.dates.push(date);
              finalReads.data.push(read.kWh_Tot_Diff);
            });
            finalReads.total = finalReads.data.reduce((a, b) => a + b);
            return finalReads;
          });
      }
  
      function getWaterData() {
        const url = `https://summary.ekmmetering.com/summary?client=Widget&meters=300000369&key=MTExOjExMQ&fields=Pulse_Cnt_1_Diff~Pulse_Ratio_1_Last~Pulse_Ratio_1_Diff~Pulse_Cnt_1_Diff~Pulse_Ratio_1_Last&report=dy&format=json&normalize=1&limit=30&timelimit=720&timezone=America~Los_Angeles`;
        return fetch(url, {
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
          .then((response) => {
            const readData = response;
            const finalReads = {};
            finalReads.data = [];
            finalReads.dates = [];
            finalReads.total = 0;
            readData.forEach((read) => {
              const date = Highcharts.dateFormat(
                "%e %b",
                read.Start_Time_Stamp_UTC_ms
              );
              finalReads.dates.push(date);
              finalReads.data.push(read.Pulse_Cnt_1_Diff * 0.1 * 7.48052);
            });
            finalReads.total = finalReads.data.reduce((a, b) => a + b);
            return finalReads;
          });
      }
  
      function getGasData() {
        const url = `https://summary.ekmmetering.com/summary?client=Widget&meters=300002822&key=NjUyMTk0MzU6UENXNWxhMUk&fields=Pulse_Cnt_1_Diff~Pulse_Ratio_1_Last~Pulse_Ratio_1_Diff~Pulse_Cnt_1_Diff~Pulse_Ratio_1_Last&report=dy&format=json&normalize=1&limit=30&timelimit=720&timezone=America~Los_Angeles`;
        return fetch(url, {
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
          .then((response) => {
            const readData = response;
            const finalReads = {};
            finalReads.data = [];
            finalReads.dates = [];
            readData.forEach((read) => {
              const date = Highcharts.dateFormat(
                "%e %b",
                read.Start_Time_Stamp_UTC_ms
              );
              finalReads.dates.push(date);
              finalReads.data.push(read.Pulse_Cnt_1_Diff);
            });
            finalReads.total = finalReads.data.reduce((a, b) => a + b);
            return finalReads;
          });
      }
      const renderChart = (reads) => {
        const checkChart1 = document.querySelector("#chart1")
        if (checkChart1) {
          Highcharts.chart('chart1', {
            accessibility: {
              enabled: false,
            },
            chart: {
              type: "spline",
              marginTop: 30,
              animation: Highcharts.svg, // don't animate in old IE
              marginRight: 10,
              events: {
                load: function () {
                  let data = [];
    
                  const makeRequest = () => {
                    getData().then((response) => {
                      data = response[0];
                    });
                  };                
    
                  makeRequest();
                  setInterval(() => makeRequest(), 6000);
    
                  // set up the updating of the chart each second
                  const series = this.series[0];
                  setInterval(() => {
                      const value = data;
                      const point = value[1];
                      const kWh_Tot = value[2];
                      
                      const time = new Date().getTime();
                      const totalText = `
                                      <div class="chart-subtitle chart-subtitle-chart1">
                                        <div><strong>Total:</strong><span style="color: #E1A322"> ${kWh_Tot} kWh</span></div>
                                        <div><span class="chart-subtitle-span-right chart-subtitle-span-right-0">Every 5 Seconds</span></div>
                                      </div>`;
                      series.addPoint([time, point], true, true);
                      series.chart.setTitle(null, {
                          text: totalText,
                          align: "center",
                          useHTML: true,
                          x: 10,
                          y: 250,
                      });
                    
                  }, 1000);
                },
              },
            },
            title: {
              text: "",
            },
            tooltip: {
              formatter: function () {
                var date = Highcharts.dateFormat("%A, %b %e, %H:%M:%S", this.x);
                var watts = Number(this.y).toLocaleString();
                return `Total Watts: <strong>${watts}<br/>
                              <br>${date}<br>Pacific Standard Time`;
              },
            },
    
            xAxis: {
              type: "datetime",
              tickPixelInterval: 15,
            },
            yAxis: {
              title: {
                text: "Total Watts",
              },
              plotLines: [
                {
                  value: 0,
                  width: 1,
                  color: "#808080",
                },
              ],
            },
            plotOptions: {
              series: {
                marker: {
                  enabled: false,
                },
              },
            },
            legend: {
              enabled: false,
            },
            exporting: {
              enabled: false,
            },
            credits: {
              enabled: false,
            },
            series: [
              {
                name: "Total Watts",
                lineWidth: 0.5,
                color: "#E1A322",
                data: reads,
              },
            ],
          });
        }; // End checkChart1
      } // End renderChart
      
  
      const renderWaterChart = (finalReads) => {
        Highcharts.setOptions({
          global: {
            useUTC: false,
          },
        });

        Highcharts.chart('chart2', {
          accessibility: {
            enabled: false,
          },
          chart: {
            type: "column",
            marginTop: 30,
            style: {
              overflow: 'visible'
            },
          },
          title: {
            text: "",
          },
          xAxis: {
            type: "datetime",
            categories: finalReads.dates.reverse(),
            crosshair: false,
          },
          yAxis: {
            min: 0,
            title: {
              text: "Daily Water (Gallons)",
            },
          },
          subtitle: {
            text: `<div class="chart-subtitle chart-subtitle-water">
                       <div><strong>Total: </strong><span style="color: #649BC4">${finalReads.total.toFixed(2)} Gal. </span></div>
                       <div><span class="chart-subtitle-span-right chart-subtitle-span-right-0">&nbsp; Last 30 Days</span></div>
                    </div>`,
            align: "left",
            useHTML: true,
            x: 10,
            y: 230,
          },
          tooltip: {
            formatter: function () {
              let value = this.y.toFixed(2);
              let cost = (0.000615 * this.y).toFixed(2);
              let day = this.x;
  
              return `<strong>${value} US Gallons</strong><br/>
                          Cost: $<strong>${cost}<br>${day}`;
            },
          },
          legend: {
            enabled: false,
          },
          exporting: {
            enabled: false,
          },
          credits: {
            enabled: false,
          },
          plotOptions: {
            column: {
              pointPadding: 0.2,
              borderWidth: 0,
              color: "#649BC4",
            },
          },
          series: [
            {
              data: finalReads.data.reverse(),
            },
          ],
        });
      };
  
      const renderElectricChart = (finalReads) => {
        Highcharts.chart('chart2', {
          accessibility: {
            enabled: false,
          },
          chart: {
            type: "column",
            marginTop: 30,
            style: {
              overflow: 'visible'
            },
          },
          title: {
            text: "",
          },
          xAxis: {
            categories: finalReads.dates.reverse(),
            crosshair: false,
          },
          yAxis: {
            min: 0,
            title: {
              text: "Daily Energy (kWh)",
            },
          },
          tooltip: {
            pointFormat: "kWh Total: <strong>{point.y:.1f} kWh</strong>",
            formatter: function () {
              let cost = (this.y * 0.18).toFixed(2);
              let day = this.x;
              return `<strong>${this.y} kWh</strong><br/>Cost: $<strong>${cost}</strong><br>${day}`;
            },
            shared: true,
            useHTML: true,
          },
          subtitle: {
            text: `<div class="chart-subtitle chart-subtitle-electricity">
                       <div><strong>Total: </strong><span style="color: #E1A322 ">${finalReads.total.toFixed(2)} kWh </span></div>
                       <div><span class="chart-subtitle-span-right subtitle-span-right-4">&nbsp; Last 30 Days</span></div>
                   </div>`,
            align: "left",
            useHTML: true,
            x: 10,
            y: 250,
          },
          legend: {
            enabled: false,
          },
          exporting: {
            enabled: false,
          },
          credits: {
            enabled: false,
          },
          plotOptions: {
            column: {
              pointPadding: 0.2,
              borderWidth: 0,
              color: "#E1A322",
            },
          },
          series: [
            {
              data: finalReads.data.reverse(),
            },
          ],
        });
      };
  
      const renderGasChart = (finalReads) => {
        Highcharts.chart('chart2', {
          accessibility: {
            enabled: false,
          },
          chart: {
            type: "column",
            marginTop: 30,
            style: {
              overflow: 'visible'
            },
          },
          title: {
            text: "",
          },
          xAxis: {
            categories: finalReads.dates.reverse(),
            crosshair: false,
          },
          yAxis: {
            title: {
              text: "Daily Natural Gas (Ft³)",
            },
          },
          subtitle: {
            text: `<div class="chart-subtitle chart-subtitle-gas">
                        <div><strong>Total: </strong><span style="color: #E26826">${finalReads.total} Ft³</span></div>
                         <div><span class="chart-subtitle-span-right subtitle-span-right-4">&nbsp; Last 30 Days</span></div>
                   </div>`,
            align: "left",
            useHTML: true,
            x: 10,
            y: 230,
          },
          tooltip: {
            formatter: function () {
              let cost = (this.y * 0.013642).toFixed(2);
              let day = this.x;
              return `<strong>${this.y} Ft³</strong><br/>Cost: $<strong>${cost}</strong><br>${day}`;
            },
            shared: true,
            useHTML: true,
          },
          legend: {
            enabled: false,
          },
          exporting: {
            enabled: false,
          },
          credits: {
            enabled: false,
          },
          plotOptions: {
            column: {
              pointPadding: 0.2,
              borderWidth: 0,
              color: "#E26826",
            },
          },
          series: [
            {
              data: finalReads.data.reverse(),
            },
          ],
        });
      };
  
      const renderWaterChartMobile = (finalReads) => {
        Highcharts.setOptions({
          global: {
            useUTC: false,
          },
        });
        const checkChart2Mobile = document.querySelector("#chart2-mobile")
        if (checkChart2Mobile){
          Highcharts.chart('chart2-mobile', {
          accessibility: {
            enabled: false,
          },
          chart: {
            type: "column",
            marginTop: 30,
          },
          title: {
            text: "",
          },
          xAxis: {
            type: "datetime",
            categories: finalReads.dates.reverse(),
            crosshair: false,
          },
          yAxis: {
            min: 0,
            title: {
              text: "Daily Water (Gallons)",
            },
          },
          subtitle: {
            text: `<div class="chart-subtitle chart-subtitle-water">
                       <div><strong>Total: </strong><span style="color: #649BC4">${finalReads.total.toFixed(2)} Gal. </span></div>
                       <div><span class="chart-subtitile-span-right chart-subtitile-span-right-0">&nbsp; Last 30 Days</span></div>
                   </div>`,
            align: "left",
            useHTML: true,
            x: 10,
            y: 230,
          },
          tooltip: {
            formatter: function () {
              let value = this.y.toFixed(2);
              let cost = (0.000615 * this.y).toFixed(2);
              let day = this.x;
  
              return `<strong>${value} US Gallons</strong><br/>
                          Cost: $<strong>${cost}<br>${day}`;
            },
          },
          legend: {
            enabled: false,
          },
          exporting: {
            enabled: false,
          },
          credits: {
            enabled: false,
          },
          plotOptions: {
            column: {
              pointPadding: 0.2,
              borderWidth: 0,
              color: "#649BC4",
            },
          },
          series: [
            {
              data: finalReads.data.reverse(),
            },
          ],
        });
        }
        
      };
  
      const renderElectricChartMobile = (finalReads) => {
        const checkChart2Mobile = document.querySelector("#chart2-mobile")
        if (checkChart2Mobile){
          Highcharts.chart('chart2-mobile', {
            accessibility: {
              enabled: false,
            },
            chart: {
              type: "column",
              marginTop: 30,
            },
            title: {
              text: "",
            },
            xAxis: {
              categories: finalReads.dates.reverse(),
              crosshair: false,
            },
            yAxis: {
              min: 0,
              title: {
                text: "Daily Energy (kWh)",
              },
            },
            tooltip: {
              pointFormat: "kWh Total: <strong>{point.y:.1f} kWh</strong>",
              formatter: function () {
                let cost = (this.y * 0.18).toFixed(2);
                let day = this.x;
                return `<strong>${this.y} kWh</strong><br/>Cost: $<strong>${cost}</strong><br>${day}`;
              },
              shared: true,
              useHTML: true,
            },
            subtitle: {
              text: `<div class="chart-subtitle chart-subtitle-electricity">
                          <div><strong>Total: </strong><span style="color: #E1A322 ">${finalReads.total.toFixed(2)} kWh </span></div>
                           <div><span class="chart-subtitle-snap-right chart-subtitle-snap-right-4">&nbsp; Last 30 Days</span></div>
                     </div>`,
              align: "left",
              useHTML: true,
              x: 10,
              y: 250,
            },
            legend: {
              enabled: false,
            },
            exporting: {
              enabled: false,
            },
            credits: {
              enabled: false,
            },
            plotOptions: {
              column: {
                pointPadding: 0.2,
                borderWidth: 0,
                color: "#E1A322",
              },
            },
            series: [
              {
                data: finalReads.data.reverse(),
              },
            ],
          });
        }
      };
  
      const renderGasChartMobile = (finalReads) => {
        const checkChart2Mobile = document.querySelector("#chart2-mobile")
        if (checkChart2Mobile){
          Highcharts.chart('chart2-mobile', {
            accessibility: {
              enabled: false,
            },
            chart: {
              type: "column",
              marginTop: 30,
              overflow: "visible",
              crop: false,
            },
            title: {
              text: "",
            },
            xAxis: {
              categories: finalReads.dates.reverse(),
              crosshair: false,
            },
            yAxis: {
              title: {
                text: "Daily Natural Gas (Ft³)",
              },
            },
            subtitle: {
              text: `<div style="display: flex; margin-left: 10%; margin-top: 60px; justify-content: space-between;">
                          <div><strong>Total: </strong><span style="color: #E26826">${finalReads.total} Ft³ </span></div>
                           <div><span style="font-family: Roboto; color: #AAAAAA; font-size: 13px; margin-left: 4%">&nbsp; Last 30 Days</div> </div>`,
              align: "left",
              useHTML: true,
              x: 10,
              y: 230,
            },
            tooltip: {
              formatter: function () {
                let cost = (this.y * 0.013642).toFixed(2);
                let day = this.x;
                return `<strong>${this.y} Ft³</strong><br/>Cost: $<strong>${cost}</strong><br>${day}`;
              },
              shared: true,
              useHTML: true,
            },
            legend: {
              enabled: false,
            },
            exporting: {
              enabled: false,
            },
            credits: {
              enabled: false,
            },
            plotOptions: {
              column: {
                pointPadding: 0.2,
                borderWidth: 0,
                color: "#E26826",
              },
            },
            series: [
              {
                data: finalReads.data.reverse(),
              },
            ],
          });
        }
      };
  
      const initialRender = (reads) => {
        renderWaterChart(reads);
        renderWaterChartMobile(reads);
      };
  
      getData(200).then((reads) => renderChart(reads));
      getWaterData().then((reads) => initialRender(reads));
    }, 4000);

  });
  